import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconButton } from '@tempmee/react';
import { OutlineRefreshIcon } from '@tempmee/react-icons';
import { JobFilters } from '../../../commonComponents/filters';
import { ListPage, ListPageTotal } from '../../../commonComponents/ListPage';
import { Table } from '../../../commonComponents/Table/Table';
import { getAdminRamUser } from '../../../../actions/userActions';
import { fetchRequestedEducations } from '../../../../actions/licensesAction';
import { useJobList } from '../../../../domain/Jobs/useCases';
import { JobType } from '../../../../domain/Jobs/enums/JobType';
import { jobListColumn, jobListConditionalRowStyles } from '../../../commonComponents/jobs-column';
import { createLoadingSelector } from '../../../../apis/selectors';

const getJobUrl = (job) => `/job/${job.id}`;
const getUserUrl = (userId, userType) => `/user/${userType.toLowerCase()}/${userId}`;

const loadingSelector = createLoadingSelector(['GET_ADMIN_RAM', 'GET_DSO_NAMES']);

export const OnsiteInterviewList = () => {
  const dispatch = useDispatch();

  const isInitialLoading = useSelector((state) => loadingSelector(state));

  useEffect(() => {
    dispatch(getAdminRamUser());
    dispatch(fetchRequestedEducations());
  }, [dispatch]);

  const {
    data,
    isLoading,
    isFetching,
    filters,
    total,
    totalFiltered,
    totalPages,
    handleFilterChanged,
    handlePageChanged,
    handleSortChanged,
    reloadJobs,
  } = useJobList({ jobType: JobType.INTERVIEW });
  const getColumn = () =>
    jobListColumn({
      getUserUrl,
      getJobUrl,
      showCounterExpiration: ['pending', 'counter', 'pending-counter'].includes(filters?.jobStatus),
      cancellationTime: true,
      isOnsiteInterview: true,
    });

  return (
    <ListPage
      title="Interviews"
      isLoading={isFetching}
      isInitialLoading={isInitialLoading}
      actions={(
        <IconButton
          aria-label="Reload interviews"
          appearance="default"
          Icon={<OutlineRefreshIcon />}
          onClick={reloadJobs}
        />
      )}
      meta={(
        <>
          <ListPageTotal value={total} />
          <ListPageTotal label={`Total ${filters.jobStatus || 'all'}`} value={totalFiltered} />
        </>
      )}
      filters={(
        // The hook keeps the applied range under `dateRange` (its `startDate`
        // key is vestigial and never written), and clearing needs no side
        // effects beyond the filter change.
        <JobFilters
          filter={filters}
          handleFilterChange={handleFilterChanged}
          appliedRange={filters.dateRange}
        />
      )}
    >
      <Table
        initialPage={filters.page}
        columns={getColumn()}
        data={data}
        noDataComponent="There are no Interviews"
        isLoading={isLoading}
        totalPages={totalPages}
        showTotal={false}
        onSort={handleSortChanged}
        paginationPerPage={filters.limit}
        paginationTotalRows={totalFiltered}
        onPageChange={handlePageChanged}
        conditionalRowStyles={jobListConditionalRowStyles}
        forceLoading={isLoading}
      />
    </ListPage>
  );
};
